import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SaleButton from "../SaleButton";
import { colors, fonts } from "../../styles";
import {
  callConductSwap,
  callShowCurrentBV3Price,
  callShowMaxSwappableBV3,
  callShowMinSwappableBV3,
  callShowSwappableUSDT,
  callShowTortuaSwapFee,
  callShowTortugaETH,
} from "../../helpers/web3";
import { showFixedDecimalPoints } from "../../helpers/utilities";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Tooltip from "../Tooltip";

export const Card = styled.div`
  width: 94%;
  max-width: 725px;
  // background: linear-gradient(254.71deg, rgba(${colors.gradDark}) 1.92%, rgba(${colors.gradLight}) 101.29%);
  background: #1b2150;
  border: 2px solid rgba(${colors.border});
  margin: 4em auto 3em;
  border-radius: 25px;
  padding: 3em;
  min-height: 490px;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    padding: 1em;
  }
`;
const SaleTitle = styled.h3`
    font-size: 32px;
    color: white;
    text-align: center;
    margin: 0;
    font-family: "Montserrat-SemiBold";
    "
`;
export const Description = styled.h5`
  font-size: 20px;
  color: #fafafa;
  opacity: 0.7;
  margin: 0.4em 0;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  a {
    text-decoration: underline;
  }
`;

const SwapAmountTextField = styled.input`
  width: 100%;
  margin: 0;
  color: rgb(${colors.white});
  font-size: ${fonts.size.h5};
  font-weight: ${fonts.weight.normal};
  outline: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  margin: 0 0.5em;
  border-bottom: 1px solid rgb(${colors.white});
`;

const AmountSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3em;
  margin-bottom: 1em;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  p {
    color: white;
  }
`;

interface Props {
  web3: any;
  setModalStatus: (status: boolean) => void;
  chainId: number;
  address: string;
  onSetModalText: (text: string) => void;
}

const TortugaInformation = (props: Props) => {
  const { web3, address } = props;
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useTranslation();
  const [tortugaETH, setTortugaETH] = useState("");
  const [swappableUSDT, setSwappableUSDT] = useState("");
  const [minSwappableBV3, setMinSwappableBV3] = useState("");
  const [maxSwappableBV3, setMaxSwappableBV3] = useState("");
  const [currentBV3Price, setCurrentBV3Price] = useState("");
  const [swapFee, setSwapFee] = useState("");
  const [swapAmount, setSwapAmount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (web3) {
      onShowTortugaETH();
      onShowSwappableUSDT();
      onShowMaxSwappableBV3();
      onShowMinSwappableBV3();
      onShowCurrentBV3Price();
      onShowTortugaSwapFee();
    }
  }, [web3]);

  const onShowTortugaSwapFee = async () => {
    let contractCall = callShowTortuaSwapFee;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }
    try {
      props.setModalStatus(true);
      // props.onSetModalText("Sending Signature");
      const result = await contractCall(address, web3);
      // props.onSetModalText("Waiting ...");
      props.setModalStatus(false);

      if (result) {
        setSwapFee(showFixedDecimalPoints(web3.utils.fromWei(result), 5));
      }
    } catch (error) {
      props.setModalStatus(false);
    }
  };

  const onShowCurrentBV3Price = async () => {
    let contractCall = callShowCurrentBV3Price;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }
    try {
      props.setModalStatus(true);
      const result = await contractCall(address, web3);
      props.setModalStatus(false);

      if (result) {
        setCurrentBV3Price(result as string);
      }
    } catch (error) {
      props.setModalStatus(false);
    } finally {
      props.setModalStatus(false);
    }
  };

  const onShowMaxSwappableBV3 = async () => {
    let contractCall = callShowMaxSwappableBV3;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }
    try {
      props.setModalStatus(true);
      const result = await contractCall(address, web3);
      props.setModalStatus(false);

      if (result) {
        setMaxSwappableBV3(
          showFixedDecimalPoints(web3.utils.fromWei(result), 2)
        );
      }
    } catch (error) {
      props.setModalStatus(false);
    }
  };

  const onShowMinSwappableBV3 = async () => {
    let contractCall = callShowMinSwappableBV3;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }
    try {
      props.setModalStatus(true);
      const result = await contractCall(address, web3);
      props.setModalStatus(false);

      if (result) {
        setMinSwappableBV3(
          showFixedDecimalPoints(web3.utils.fromWei(result), 2)
        );
      }
    } catch (error) {
      props.setModalStatus(false);
    }
  };

  const onShowSwappableUSDT = async () => {
    let contractCall = callShowSwappableUSDT;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }
    try {
      props.setModalStatus(true);
      const result = await contractCall(address, web3);
      props.setModalStatus(false);

      if (result) {
        setSwappableUSDT(result as string);
      }
    } catch (error) {
      props.setModalStatus(false);
    }
  };

  const onShowTortugaETH = async () => {
    let contractCall = callShowTortugaETH;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }
    try {
      props.setModalStatus(true);
      const result = await contractCall(address, web3);
      props.setModalStatus(false);

      if (result) {
        setTortugaETH(showFixedDecimalPoints(web3.utils.fromWei(result), 2));
      }
    } catch (error) {
      props.setModalStatus(false);
    }
  };

  const handleSwapAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (loading) return;

    try {
      if (e.currentTarget.value === "" || e.currentTarget.value === ".") {
        setSwapAmount(e.currentTarget.value);
      } else if (!isNaN(Number(e.currentTarget.value))) {
        setSwapAmount(e.currentTarget.value);
      }
    } catch (error) {}
  };

  const handleConductSwap = async () => {
    let contractCall = callConductSwap;
    if (!contractCall) {
      throw new Error(
        `No matching contract calls for functionSig= callGetAuctions`
      );
    }

    if (Number(swapAmount) === 0) {
      toast.error("Amount must be bigger than 0.");
      return;
    }

    if (
      Number(swapAmount) < Number(minSwappableBV3) ||
      Number(swapAmount) > Number(maxSwappableBV3)
    ) {
      toast.error("Please fix the amount to swap.");
      return;
    }
    setLoading(true);
    try {
      props.setModalStatus(true);
      const result = await contractCall(address, web3, swapAmount);
      if (result) {
        toast.success("Transaction Successful");
      } else {
        toast.error("Transaction Failed");
        setShowTooltip(true);
      }
      setSwapAmount("");
    } catch (error) {
      setShowTooltip(true);
      toast.error("Transaction Failed");
    } finally {
      props.setModalStatus(false);
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Card style={{ marginBottom: showTooltip ? "20px" : "0px" }}>
        <SaleTitle style={{ marginBottom: 30 }}>{t("Tortuga")}</SaleTitle>
        <Description>{`${t("ETHInTortuga")}: ${tortugaETH}`}</Description>
        {/* <Description>Maximum USDT Value: {swappableUSDT}</Description> */}
        <Description>{`${t(
          "MaximumBV3Swappable"
        )}: ${maxSwappableBV3}`}</Description>
        <Description>{`${t(
          "MinimumBV3Swappable"
        )}: ${minSwappableBV3}`}</Description>
        {/* <Description>Current BV3 price: {currentBV3Price}</Description> */}
        <Description>{`${t("CurrentSwapFee")}: ${swapFee}`}</Description>
        <AmountSection>
          <Description
            style={{ marginTop: 50, margin: 0, whiteSpace: "nowrap" }}
          >
            {`${t("EnterAmountBUCCToSwap")}:`}
          </Description>
          <InputContainer>
            <SwapAmountTextField
              placeholder="0.00"
              value={swapAmount}
              onChange={handleSwapAmount}
            ></SwapAmountTextField>
            {/* <MinMax>
            <p>Min xx</p>
            <p>Max xx</p>
          </MinMax> */}
          </InputContainer>
        </AmountSection>

        {/* <SaleTitle>ETH to recieve:</SaleTitle>
      <SaleTitle>XX</SaleTitle>
      <Description>Swap recipient:</Description>
      <UnderLineTextField placeholder="0x00000000000000000000000"></UnderLineTextField> */}
        <SaleButton title={t("SwapBV3AForETH")} onClick={handleConductSwap} />
      </Card>
      <Tooltip
        text={t("TortugaTooltip")}
        show={showTooltip}
        setVisible={setShowTooltip}
      />
    </div>
  );
};

export default TortugaInformation;
